export function HarriEngageFavFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/harri-engage-fav-filled.svg'"></ng-include>`
    }
}
